import { Bounce, toast, ToastOptions } from "react-toastify";

const showToast = (
  message: string,
  type: "success" | "error" | "info" | "warning" | "default"
) => {
  // Ensure message is clean and not empty
  const cleanMessage = message?.trim() || "An action occurred";
  
  const toastOptions: ToastOptions = {
    position: "top-right",
    autoClose: type === "error" ? 4000 : 3000, // Slightly shorter for errors
    hideProgressBar: false,
    closeOnClick: true, // Allow click to close
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    transition: Bounce,
  };

  // Prevent duplicate toasts
  const toastId = `${type}-${cleanMessage}`;

  if (type === "success") {
    toast.success(cleanMessage, { ...toastOptions, toastId });
  } else if (type === "error") {
    toast.error(cleanMessage, { ...toastOptions, toastId });
  } else if (type === "info") {
    toast.info(cleanMessage, { ...toastOptions, toastId });
  } else if (type === "warning") {
    toast.warning(cleanMessage, { ...toastOptions, toastId });
  } else {
    toast(cleanMessage, { ...toastOptions, toastId });
  }
};

export default showToast;
